<template>
	<div>
		{{ $t('common.accessDenied') }}
	</div>
</template>

<script>

export default {
	name: 'AccessDenied'
}
</script>
